(() => {
  'use strict';
  function init(scope) {
    scope.querySelectorAll('[data-bea-video]:not([data-video-ready])').forEach(box => {
      box.dataset.videoReady = 'true';
      const button = box.querySelector('button');
      if (!button || !/^[A-Za-z0-9_-]{11}$/.test(box.dataset.beaVideo)) return;
      button.hidden = false;
      button.addEventListener('click', () => {
        const frame = document.createElement('iframe');
        frame.src = 'https://www.youtube-nocookie.com/embed/' + box.dataset.beaVideo + '?autoplay=1&rel=0';
        frame.title = box.dataset.videoTitle || 'Bea Nature Video';
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        box.querySelector('.BeaStory__poster')?.remove();
        button.replaceWith(frame);
        box.classList.add('is-playing');
        frame.focus();
      }, {once: true});
    });
    scope.querySelectorAll('[data-bea-contents]:not([data-contents-ready])').forEach(body => {
      body.dataset.contentsReady = 'true';
      const headings = [...body.querySelectorAll('h2,h3')].filter(h => !h.closest('[data-no-toc]') && h.textContent.trim());
      if (headings.length < 3) return;
      const details = document.createElement('details');
      details.className = 'BeaStory__toc';
      const summary = document.createElement('summary');
      summary.textContent = 'Das findest du in diesem Beitrag';
      const list = document.createElement('ol');
      const prefix = body.dataset.beaContents || 'bea-abschnitt';
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = prefix + '-' + (index + 1);
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = '#' + heading.id;
        a.textContent = heading.textContent.trim();
        li.append(a); list.append(li);
      });
      details.append(summary,list); body.prepend(details);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
